module.exports = __webpack_public_path__ + "static/media/forms.d9c45568.svg";